"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateAccountPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="fixed-background"
    style="background: url(/assets/images/laptop-5673901_1280.jpg) no-repeat 50% fixed; background-size: cover;">
</div>
<main>
    <div id="firstpages-lang">
        <lang-switcher></lang-switcher>
    </div>
    <div class="container">
        <div class="h-100 row">
            <div class="mx-auto my-auto col-12 col-md-10">
                <div class="auth-card card">
                    <div class="position-relative image-side "
                        style="background:url(/assets/images/keyboard-5017973_1280.jpg); background-size: cover;">
                        <p class="text-white h2">${'activate.hero.title'.t()}</p>
                        <p class="white mb-0">
                            ${'activate.hero.description'.t()}
                            <br>${'activate.hero.login_link_text'.t()}
                            <a href="/">${'activate.hero.login_link'.t()}</a>.
                        </p>
                    </div>
                    <div class="form-side">
                        <a aria-current="page" class="active h4 mb-4 d-block" href="/">
                            ${'activate.page.title'.t()}
                        </a>
                        
                        ${(0, fast_element_1.when)(x => x.isActivating, (0, fast_element_1.html) `
                            <div class="text-center">
                                <div class="mb-4">
                                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="mb-4 card-title">${'activate.loading.title'.t()}</div>
                                <p class="text-muted">${'activate.loading.message'.t()}</p>
                            </div>
                        `)}
                        
                        ${(0, fast_element_1.when)(x => !x.isActivating && x.activationResult && x.isActivated, (0, fast_element_1.html) `
                            <div class="text-center">
                                <div class="mb-4">
                                    <i class="icon-check2 text-success" style="font-size: 3rem;"></i>
                                </div>
                                <div class="mb-4 card-title">${'activate.success.title'.t()}</div>
                                <p class="text-muted mb-4">${'activate.success.description'.t()}</p>
                                <a href="/" class="btn btn-primary btn-lg">
                                    ${'activate.button.login'.t()}
                                </a>
                            </div>
                        `)}
                        
                        ${(0, fast_element_1.when)(x => !x.isActivating && x.activationResult && !x.isActivated, (0, fast_element_1.html) `
                            <div class="text-center">
                                <div class="mb-4">
                                    <i class="icon-close text-danger" style="font-size: 3rem;"></i>
                                </div>
                                <div class="mb-4 card-title">${'activate.error.title'.t()}</div>
                                <p class="text-muted mb-4">${x => { var _a; return ((_a = x.activationResult) === null || _a === void 0 ? void 0 : _a.error) || 'activate.error.generic'.t(); }}</p>
                                <div class="d-flex justify-content-center gap-2">
                                    <a href="/" class="btn btn-primary btn-lg">
                                        ${'activate.button.back_login'.t()}
                                    </a>                                   
                                </div>
                            </div>
                        `)}
                        
                        ${(0, fast_element_1.when)(x => !x.isActivating && !x.activationResult, (0, fast_element_1.html) `
                            <div class="text-center">
                                <div class="mb-4">
                                    <i class="icon-warning text-warning" style="font-size: 3rem;"></i>
                                </div>
                                <div class="mb-4 card-title">${'activate.error.invalid_link'.t()}</div>
                                <p class="text-muted mb-4">${'activate.error.invalid_link_description'.t()}</p>
                                <a href="/" class="btn btn-primary btn-lg">
                                    ${'activate.button.back_login'.t()}
                                </a>
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  height: 100%;
  display: block;
}

#firstpages-lang {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
}

main {
  margin: 0 !important;
  height: 100%;
}
main .container {
  height: 100%;
}
main a {
  color: var(--primary-color);
}
main .icon-check2 {
  color: #28a745 !important;
}`;
const shadowOptions = { "mode": "open" };
let ActivateAccountPage = class ActivateAccountPage extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.token = '';
        this.isActivating = false;
        this.activationResult = null;
        this.isActivated = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.togglePreloader();
        if (this.token) {
            await this.activateAccount();
        }
    }
    getBody() {
        return document.querySelector('body');
    }
    getPreloader() {
        return document.querySelector('#preloader');
    }
    togglePreloader() {
        const preloader = this.getPreloader();
        if (preloader.classList.contains('hidden')) {
            preloader.classList.remove('hidden');
        }
        else {
            preloader.classList.add('hidden');
        }
    }
    async activateAccount() {
        if (!this.token) {
            this.activationResult = {
                success: false,
                error: 'activate.error.no_token'.t()
            };
            return;
        }
        this.isActivating = true;
        try {
            const response = await this.apiService.back.post('auth.activate', {
                token: this.token
            });
            this.activationResult = response;
            this.isActivated = response.success;
            if (response.success) {
                this.notifyService.notify('activate.success.message'.t(), 'info');
            }
            else {
                this.notifyService.notify(response.error || 'activate.error.generic'.t(), 'error');
            }
        }
        catch (error) {
            this.activationResult = {
                success: false,
                error: 'activate.error.network'.t()
            };
            this.notifyService.notify('activate.error.network'.t(), 'error');
        }
        finally {
            this.isActivating = false;
        }
    }
    goToLogin() {
        component_1.SiteMenu.goto.bind(this)('/login');
    }
    goToRegister() {
        component_1.SiteMenu.goto.bind(this)('/register');
    }
};
exports.ActivateAccountPage = ActivateAccountPage;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ActivateAccountPage.prototype, "token", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ActivateAccountPage.prototype, "isActivating", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], ActivateAccountPage.prototype, "activationResult", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ActivateAccountPage.prototype, "isActivated", void 0);
exports.ActivateAccountPage = ActivateAccountPage = __decorate([
    (0, client_1.RWSView)('activate-account-page', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ActivateAccountPage);
ActivateAccountPage.defineComponent();
